/*
  This code is the intellectual property of Bulb Inc. and other software publishers;
  it may not be altered, copied or disclosed without prior written approval.
  Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Component, Input } from '@angular/core';
import { ImageAsset } from '../types';

export enum AttributionPosition {
  topLeft = 'tl',
  topRight = 'tr',
  bottomRight = 'br',
  bottomLeft = 'bl',
}

/**
 * An image component with support for displaying image attribution.
 * The attribution location can be chosen from any of the four corners.
 * The rendered image should be centered within the component's frame,
 * cropping will occur if the frame doesn't match the image's aspect ratio.
 */
@Component({
  selector: 'bulb-cover-image[imageDesc]',
  templateUrl: './cover-image.component.html',
  styleUrls: ['./cover-image.component.scss'],
  standalone: false,
})
export class CoverImageComponent {
  /**
   * The image data, including attribution details.
   */
  @Input() imageAsset: ImageAsset;

  /**
   * Accessible text for the image.
   */
  @Input() imageDesc: string;

  /**
   * The position to display the attribution link in.
   */
  @Input() attPosition: AttributionPosition = AttributionPosition.bottomRight;

  /**
   * Whether or not to initiate image zoom effect
   */
  @Input() isImageZoom: boolean;

}
